import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { ReplacePreviewContentProvider } from './replaceService.js';
import { registerWorkbenchContribution2 } from 'vscode/vscode/vs/workbench/common/contributions';

function registerContributions() {
    registerWorkbenchContribution2(ReplacePreviewContentProvider.ID, ReplacePreviewContentProvider, 1 );
}

export { registerContributions };
